<template>
  <div id="Overview" class="reportHeader">
    <div class="pageHeader">
      <div class="row">
        <div class="col-xs-12">
          <hr />
        </div>
      </div>

      <div class="row">
        <div class="col-xs-6">
          <div class="mr-2" :class="getFlag(report.companyoverview.registeredaddress.country.code)"></div>
          <company-status :company-overview="report.companyoverview" />
        </div>
        <div class="col-xs-6" style="text-align: right">
          <h6>{{ formatDate(report.companyoverview.created_at) }}</h6>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import toolsMixin from '@/components/reports/ToolsMixin';
import CompanyStatus from './CompanyStatus';

export default {
  components: { CompanyStatus },
  mixins: [toolsMixin],
  props: ['report', 'pdf'],
};
</script>

<style></style>
